import ovalIcon from 'assets/oval.svg';
import puffIcon from 'assets/puff.svg';
import blueOval from 'assets/oval_blue.svg';
import { useTranslation } from 'react-i18next';

const variants = {
  blue: blueOval,
  puff: puffIcon,
  white: ovalIcon,
};

const Loader = ({ variant, isCentered, ...rest }) => {
  const { t } = useTranslation();

  const loader = (
    <img alt={t('components.loading_icon')} src={variants[variant] || variants.blue} {...rest} />
  );

  if (isCentered) {
    return <div style={{ textAlign: 'center', padding: '1rem' }}>{loader}</div>;
  }

  return loader;
};

export default Loader;
